/**
 * Model containing id(s) respective to selected entity, to be passed to child components.
 */
export class EntityIdDetails {
  entityId: number;
  orgId: number;
  clientId: number;
  personId: number;
  entityType: EntityType;

  get isClient(): boolean {
    return this.entityType === EntityType.CLIENT;
  }

  get isPerson(): boolean {
    return this.entityType === EntityType.PERSON;
  }

  get isOrg(): boolean {
    return this.entityType === EntityType.ORGANISATION;
  }
}

/**
 * Enum for representing type of entity.
 */
export enum EntityType {
  ORGANISATION = <any>'ORGANISATION',
  CLIENT = <any>'CLIENT',
  PERSON = <any>'PERSON'
}



// WEBPACK FOOTER //
// ./src/app/shared/models/entity-id-details.model.ts